import { styled } from 'linaria/react';

export const PriceCalculateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--space-300);
  margin-top: var(--space-300);
  background: var(--service-light);
  border-radius: var(--space-100);
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-100);
`;
